import { Box } from '@chakra-ui/react'

import { makeServerProps } from '@/server/query'

import { DEFAULT_BLOG_PAGE_SIZE } from '@/client/services/blog'
import makePage from '@/client/services/pages/makePage'

import BlogArticleList from '@/components/Blog/BlogArticleList'
import BlogHeader from '@/components/Blog/BlogHeader'
import useBlogArticles from '@/components/Blog/hooks/useBlogArticles'
import Layout from '@/components/Layout/Layout'
import { useOffset } from '@/components/Pagination/Pagination'
import Container from '@/components/Worlds/UI/Container/Container'

function BlogIndex() {
  const offset = useOffset(DEFAULT_BLOG_PAGE_SIZE)

  const { blogArticles, countTotalItems } = useBlogArticles({
    limit: DEFAULT_BLOG_PAGE_SIZE,
    offset,
  })

  const { blogArticles: pinnedBlogArticles } = useBlogArticles({ pinnedTo: 'global' })

  return (
    <Layout title="Schoolhouse Blog" ignoreTitleSuffix>
      <Container>
        <BlogHeader currentTab="All" />
        {pinnedBlogArticles.length === 0 ? null : (
          <Box mb="36px">
            <BlogArticleList
              blogArticles={pinnedBlogArticles}
              columns={1}
              pinnedToContext="global"
            />
          </Box>
        )}
        <BlogArticleList
          blogArticles={blogArticles.filter(article => article.pinnedTo !== 'global')}
          paginationConfig={{ countTotalItems, pageSize: DEFAULT_BLOG_PAGE_SIZE, offset }}
        />
      </Container>
    </Layout>
  )
}

const BlogIndexPage = makePage(BlogIndex, {
  blockedUsers: 'allowed',
  onboardingUsers: 'allowed',
})

export const getServerSideProps = makeServerProps(BlogIndexPage)
export default BlogIndexPage
